<template>
<div class="update-adaptive-game-show-path">
  <div class="border-left-right-1px padding-top-2px padding-bottom-2px">
    <div class="row vertical-align">  
      <div class="col-md-12 col-lg-12 text-align-left">
        <div class="container-fluid">
          <span class="font-weight-bold font-size-15px">{{currIndexValue + 1}}.&nbsp;&nbsp;</span><span>{{currPathValue}}</span>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  props: ['currPath', 'currIndex'],
  data: function () {
    return {}
  },
  name: 'update-adaptive-game-show-path',
  methods: {},
  components: {},
  computed: {
    currPathValue: {
      get: function () {
        return this.currPath
      }
    },
    currIndexValue: {
      get: function () {
        return this.currIndex
      }
    }
  }
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-top-2Perc
{
	margin-top: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
    border:1px solid red;
}
.border-white {
    border:1px solid white;
}
.margin-bottom-2Perc {
    margin-bottom: 2%;
}
.font-size-14px {
    font-size: 14px;
}
.padding-right-6px {
    padding-right:6px; 
}
.padding-top-1Perc {
    padding-top:1%;
}
.padding-left-0px {
    padding-left:0px;
}
.font-size-12px {
  font-size:12px;
}
.padding-left-right-0px {
  padding-left:0px;
  padding-right:0px;
}
.padding-left-15px {
  padding-left: 15px;
}
.padding-left-25px {
  padding-left:25px;
}
.border-top-dotted {
  border-top: 1px dotted; 
}
.border-top-1px {
  border-top: 1px solid #aaa;
}
.border-bottom-1px {
  border-bottom: 1px solid #aaa;
}
.border-1px {
  border: 1px solid #aaa;
}
.border-right-solid {
  border-right: 1px solid #aaa;
}
.border-bottom-dotted {
  border-bottom: 1px dotted;
  border-color: #aaa;
}
.border-left-solid {
  border-left: 1px solid;
  border-color: #aaa;
}
.padding-left-12px {
  padding-left: 12px;
}
.padding-right-13px {
  padding-left: 13px;
}
.padding-left-10px {
  padding-left:10px;
}
.padding-top-9px {
  padding-top:9px;
}
.padding-top-45px {
  padding-top:45px;
}
.padding-bottom-43px {
  padding-bottom:43px;
}
.padding-top-bottom-10px {
  padding-top:10px;
  padding-bottom: 10px;
}
.padding-top-bottom-9px {
  padding-top:9px;
  padding-bottom: 9px;
}
.padding-top-17px {
  padding-top:17px;
}
.padding-bottom-54px {
  padding-bottom:54px;
}
.padding-top-54px {
  padding-top:54px;
}
.padding-bottom-10px {
  padding-bottom: 10px;
}
.text-align-left {
  text-align:left;
}
.padding-left-3px {
  padding-left:3px;
}
.padding-left-6px {
  padding-left:6px;
}
.padding-left-9px {
  padding-left:9px
}
.padding-right-20px {
  padding-right:20px;
}
.padding-top-2Perc {
  padding-top:2%;
}
.padding-right-8px {
  padding-right:8%;
}
.padding-left-21px {
  padding-left:21px;
}
.height-106px {
  height:106px;
}
.height-163px {
  height: 163px;
}
.height-164Point766px {
  height: 164.766px;
}
.center-content {
    margin: auto;
    width: 60%;
    border: 3px solid #73AD21;
    padding: 10px;
}
.text-vertical-center {
    padding: 69px 0;
    text-align: center;
}
.audio-text-vertical-center {
  padding: 14px 0;
  text-align: center;
}
.background-color {
  background-color: #eee;
}
.height-52px {
  height: 52px;
}
.margin-bottom-15px {
  margin-bottom: 15px;
}
.border-light-grey {
 border: 1px solid #d6d6d6;   
}
.btn-padding-6px-28px {
  padding:6px 28px;
}
.margin-bottom-2px {
  margin-bottom: 2px !important;
}
.padding-top-bottom-15px {
  padding-top:15px;
  padding-bottom:15px;
}
.font-weight-bold {
  font-weight:bold;
}
.font-size-15px {
  font-size:15px;
}
.padding-top-2px {
  padding-top: 2px;
}
.padding-bottom-2px {
  padding-bottom: 2px;
}
.border-left-right-1px {
  border-left: 1px solid #aaa;
  border-right: 1px solid #aaa;
}
</style>


// WEBPACK FOOTER //
// src/components/adaptive_game/Update-element/UpdateAdaptiveGameShowPath.vue